import { render, staticRenderFns } from "./PrivateExercisesPage.vue?vue&type=template&id=0d82fce6&"
import script from "./PrivateExercisesPage.vue?vue&type=script&lang=js&"
export * from "./PrivateExercisesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports